import { spawn } from 'redux-saga/effects';

import { watchIntakeFormUpload } from './uploadHeadshot';

export default function* saga() {
  yield spawn(watchIntakeFormUpload);
}
